import { ToastContainerDS, PageDS, TabMenu, Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TransactionsCards } from "./cards";
import { TransactionsBadges } from "./badges";

export const DepartmentTransactions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(params.tab ?? "cards");

  const tabs = useMemo(() => {
    return [
      {
        name: "cards",
        title: t("transactions.tab.cards"),
      },
      {
        name: "badges",
        title: t("transactions.tab.badges"),
      },
    ];
  }, [t]);

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/departments/transactions/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  return (
    <PageDS
      title={t("transactions.title")}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={0.5} />
        </>
      }
      supportButton={{
        showMail: true,
      }}
    >
      <TransactionsCards />
      <TransactionsBadges />
    </PageDS>
  );
};
